<template>
  <div class="main-page" ref="scrollMenuRef">
    <!--  父菜单  -->
    <el-collapse-transition v-if="!isManage">
      <el-row v-if="navigateShow" class="menu-class" style="position: fixed; z-index: 1000; width: 100%; top: 0;">
        <el-col style="width: 26%;height: 100%;">
          <el-row class="top-navigate">
            <el-row class="company-logo" @click.native="selectMenu(menuList[0])" />
          </el-row>
        </el-col>
        <el-col style="width: 49%;height: 100%;display: flex;">
          <el-row v-for="(data, i) in menuList" :key="i" class="title-class" @click.native="selectMenu(data)">
            <el-row :class="selMenu === data.id ? 'link-text-hover' : 'link-text'" @mouseover.native="overMenu(i, data)" @mouseleave.native="leaveMenu(i)">
              {{data.name}}
            </el-row>
          </el-row>
        </el-col>
        <el-col style="width: 25%;height: 100%;">
          <el-row style="width: 100%;height: 86px;"/>
        </el-col>
      </el-row>
    </el-collapse-transition>
    <!--  子菜单  -->
    <el-row v-if="!isManage" v-show="popShow" class="pop-class" :style="{'left': (26 + 7 * hoverMenu) + '%'}" @mouseover.native="overPop" @mouseleave.native="leavePop">
      <pop-over-down :data-list="dataList" @clickSub="clickSub" />
    </el-row>
    <div v-if="!isManage" @mouseover="showTel = true" @mouseleave="showTel = false" class="right-tool-class" style="top: calc(40% - 40px);">
      <i class="yk-icon-phone" style="font-size: 36px;" />
    </div>
    <div v-if="showTel" style="position: fixed;z-index: 10000;top: calc(40% - 30px);right: 84px;width: 160px;height: 60px;display: flex;color: #ffffff;">
      <div style="width: 150px;line-height: 60px;background-color: #377FED;font-size: 18px;border-radius: 3px;">18627018350</div>
      <div class="triangle" style="margin-top: 25px;"></div>
    </div>
    <div v-if="!isManage" @mouseover="showWeixin = true" @mouseleave="showWeixin = false" class="right-tool-class" style="top: calc(40% + 120px);">
      <i class="yk-icon-weixin1" style="font-size: 36px;" />
    </div>
    <div v-if="showWeixin" style="position: fixed;z-index: 10000;top: calc(40% + 100px);right: 84px;width: 130px;height: 120px;display: flex;">
      <div class="qrcode-img" />
      <div class="triangle" style="margin-top: 55px;"></div>
    </div>
    <router-view />
    <!--  页尾  -->
    <footer-page v-if="!isManage" />
  </div>
</template>

<script>
import PopOverDown from './PopOverDown'
import HomePage from './home/HomePage'
import IntroducePage from './introduce/IntroducePage'
import Product from './product/ProdPage'
import Solution from './solution/SoluPage'
import NewsPage from './news/NewsPage'
import FooterPage from './FooterPage'
export default {
  name: 'MainPage',
  components: { PopOverDown, HomePage, IntroducePage, Product, Solution, NewsPage, FooterPage },
  data() {
    return {
      mapOption: null,
      navigateShow: true,
      scrollTop: 0,
      menuList: [
        {id: '1', name: '首页', data: [], component: '/'},
        {id: '2', name: '走进瑜岿', data: [{id: '21', name: '公司简介', parentId: '2', component: '/short_introduce'}, {id: '22', name: '企业文化', parentId: '2', component: '/culture'}, {id: '23', name: '资质荣誉', parentId: '2', component: '/honor'}, {id: '24', name: '核心团队', parentId: '2', component: '/team'}]},
        {id: '3', name: '产品中心', data: [{id: '31', name: '软件', parentId: '3', component: '/software', param: '311'}, {id: '32', name: '硬件', parentId: '3', component: '/hardware', param: '321'}]},
        {id: '4', name: '解决方案', data: [{id: '41', name: '绿色高校', parentId: '4', component: '/solution', param: '411'}, {id: '42', name: '绿色工厂', parentId: '4', component: '/solution', param: '412'}, {id: '43', name: '智慧园区', parentId: '4', component: '/solution', param: '413'}]},
        {
          id: '5',
          name: '云平台',
          data: [
            {id: '51', name: '综合能碳管理平台', parentId: '5', 'url': 'https://ems.yukui-tech.com'},
            {id: '52', name: '智能配电平台', parentId: '5', 'url': 'https://doms.yukui-tech.com'},
            {id: '53', name: '数字光伏平台', parentId: '5', 'url': 'https://soms.yukui-tech.com'},
            {id: '54', name: '安全用电平台', parentId: '5', 'url': 'https://safe.yukui-tech.com'}
          ]
        },
        // {id: '6', name: '加入瑜岿', data: []},
        {id: '7', name: '新闻资讯', data: [], component: '/news'},
        {id: '8', name: '加盟代理', data: [], component: '/contact'}
      ],
      dataList: [],
      selMenu: '1',
      subMenu: '',
      subInd: '',
      subId: '',
      hoverMenu: 0,
      popShow1: false,
      popShow2: false,
      params: {},
      dict: {'/': '1', '/short_introduce': '2', '/culture': '2', '/honor': '2', '/team': '2', '/software': '3', '/hardware': '3', '/solution': '4', '/news': '7', '/contact': '8'},
      isManage: false,
      showTel: false,
      showWeixin: false
    }
  },
  computed: {
    popShow() {
      return this.popShow1 || this.popShow2
    }
  },
  created() {
    if (this.$route.path === '/login' || this.$route.path === '/manage_news') {
      this.isManage = true
    }
    this.selMenu = this.dict[this.$route.path]
  },
  mounted() {
    // 监听浏览器/页面滚动条的滚动
    window.addEventListener('scroll', this.scrollContent)
  },
  watch: {
    $route: {
      handler(val) {
        if (this.$route.path === '/login' || this.$route.path === '/manage_news') {
          this.isManage = true
        } else {
          this.isManage = false
          this.selMenu = this.dict[this.$route.path]
        }
      },
      deep: true
    }
  },
  methods: {
    selectMenu(data) {
      if (data.data.length === 0) {
        if (this.selMenu === data.id) {
          location.reload()
        } else {
          this.selMenu = data.id
          this.$router.push(data.component)
        }
      }
    },
    overMenu(i, data) {
      if (data.data.length > 0) {
        this.dataList = data.data
        this.popShow1 = true
        this.hoverMenu = i
      }
    },
    leaveMenu(i) {
      let _this = this
      setTimeout(function () {
        if (i === _this.hoverMenu) {
          _this.popShow1 = false
          if (!(_this.popShow1 || _this.popShow2)) {
            _this.dataList = []
          }
        }
      }, 100)
    },
    overPop() {
      this.popShow2 = true
    },
    leavePop() {
      let _this = this
      setTimeout(function() {
        _this.popShow2 = false
      }, 100)
    },
    clickSub(data, i) {
      if (data.url) {
        window.open(data.url, '_blank')
      } else if (data.component) {
        this.popShow2 = false
        this.selMenu = data.parentId
        if (data.param) {
          this.$router.push({path: data.component, query: {'page': data.param}})
        } else if (data.component !== this.$route.path) {
          this.$router.push(data.component)
        }
      }
    },
    clickHome(selMenu, subId, params) {
      this.selMenu = selMenu
      this.subId = subId
      this.params = params
    },
    scrollContent() {
      // scrollTop为显示屏顶部与整个文档顶部间的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let scroll = scrollTop - this.scrollTop
      this.scrollTop = scrollTop
      if (this.navigateShow === true && scroll > 0) {
        this.navigateShow = false
      } else if (this.navigateShow === false && scroll < 0) {
        this.navigateShow = true
      }
    }
  }
}
</script>

<style scoped>
  .main-page {
    width: 100%;
    height: 100%;
  }
  .menu-class {
    background: #ffffff;
    height: 86px;
    color: #000000;
    border-bottom: 1px solid #dddddd;
  }
  .title-class {
    width: 20%;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .title-class:hover {
    color: #00bf86;
    cursor: pointer;
  }
  .link-text {
    color: #000000;
    width: 100%;
    height: 62px;
    line-height: 62px;
    font-size: 16px;
  }
  .link-text-hover {
    color: #00bf86;
    width: 100%;
    height: 62px;
    line-height: 62px;
    font-size: 16px;
  }
  .link-text:hover {
    color: #00bf86;
  }
  .top-navigate {
    width: 100%;
    height: 86px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .company-logo {
    background-image: url("../assets/icon5.png");
    width: 220px;
    height: 40px;
    background-size: cover;
    cursor: pointer;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .pop-class {
    background-color: #ffffff;
    color: #000000;
    position: fixed;
    z-index: 1000;
    top: 74px;
    width: 9%;
    border: 1px solid #eeeeee;
  }
  .triangle {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 10px solid #377FED;
  }
  .qrcode-img {
    background-image: url("../assets/img/qrcode_user.jpg");
    width: 120px;
    height: 120px;
    background-size: cover;
  }
  .right-tool-class {
    position: fixed;
    z-index: 10000;
    right: 10px;
    width: 70px;
    height: 80px;
    line-height: 80px;
    background-color: #377FED;
    border: 1px solid #DCDCDC;
    border-radius: 3px;
    cursor: pointer;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue